


























import { Component, Vue } from 'vue-property-decorator'
import { BRow, BCol } from 'bootstrap-vue'
import chunk from 'lodash/chunk'

import ProductsApi from '@cms-labs/typescript-api/products'
import { ProductCollectionItemPublic } from '@cms-labs/typescript-api/products/types'

import { app } from '../../main'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import ProductCollectionItem from '@/components/products/ProductCollectionItem.vue'

@Component({
  components: { BRow, BCol, ProductCollectionItem, LoadingOverlay }
})
export default class TopProducts extends Vue {
  // A Collection of the Top 8 products of the store.
  private isLoading = false
  private TopProducts: ProductCollectionItemPublic[] = []

  private async created (): Promise<void> {
    try {
      this.isLoading = true
      const http = new ProductsApi(app)
      const resp = await http.getProductCollection(null, null, 8, 'views')
      if (resp) { this.TopProducts = resp }
      this.isLoading = false
    } catch (error) { this.isLoading = false }
  }

  private getArrayChunks (
    inputArray: Array<ProductCollectionItemPublic>,
    chunkSize: number
  ) {
    return chunk(inputArray, chunkSize)
  }
}
